import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../atoms/Icon';

class SingleDepCheckbox extends React.Component {
	constructor(props) {

	  super(props);
	  this.handleClick = this.handleClick.bind(this);
	  this.state = {
        active: props.active,
        init:false
     };
	}
	componentDidMount() {
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:nextState});
		this.props.onClick(this.props.id, nextState);
	}


    render () {
        return (
          <div className={`orderformsingledepcheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc">
	            	<div className="subline" style={{color:"black"}}>
	              		{this.props.desc}
            	    </div>
            	</div>
            </div>
          </div>
        );
    }

}

SingleDepCheckbox.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
	desc:PropTypes.string,
    active:PropTypes.bool
}

SingleDepCheckbox.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a SingleDepCheckbox Component!', event.target);
	},
	desc: "",
    active: false
	
}

export default SingleDepCheckbox







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormDepCheckboxes/SingleDepCheckbox.js